<template>
	<section class="view-ui-state-loader">
		<section class="text-center">
			<img src="~@chalkysticks/sass/build/asset/image/loader/triangle-white.svg" />
		</section>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Generic loading state indicator for lists and content areas.
	 *
	 * Displays a centered loading spinner while data is being fetched.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateLoader extends ViewBase {
		// Intentionally empty - pure presentational component
	}
</script>

<style lang="scss">
	.view-ui-state-loader {
		align-items: center;
		background-color: var(--chalky-blue);
		border-radius: var(--border-radius);
		display: flex;
		height: 100%;
		justify-content: center;
		opacity: 0.75;
	}
</style>
